<template>
	<div>
		<v-dialog
			:value="true"
			max-width="400"
			@click:outside="handleClose"
			@keydown.esc="handleClose"
		>
			<v-card>
				<ValidationObserver ref="form" tag="form" @submit="handleSubmit">
					<v-container>
						<v-row>
							<v-col>
								<ValidationProvider rules="required" v-slot="{ errors }">
									<v-text-field
										v-model="locationEditable.name"
										outlined
										:label="$t('label.name')"
										:error-messages="errors"
										hide-details
										dense
									></v-text-field>
								</ValidationProvider>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<fieldset
									class="talentics-fieldset talentics-fieldset-paddings"
								>
									<legend>
										{{ $t('label.status') }}:
										{{
											locationEditable.active
												? $t('label.active')
												: $t('label.inactive')
										}}
									</legend>
									<v-switch
										v-model="locationEditable.active"
										color="success"
										inset
										hide-details
										dense
										class="v-input--template-switch"
									></v-switch>
								</fieldset>
							</v-col>
						</v-row>
					</v-container>
				</ValidationObserver>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="handleClose">{{
						$t('button.close')
					}}</v-btn>
					<v-btn
						color="error"
						outlined
						@click="hanleDeleteClick"
						v-if="method === 'edit'"
						>{{ $t('button.delete') }}</v-btn
					>
					<v-btn color="primary" @click="handleSubmit">{{
						$t('button.save')
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<Confirm
			v-if="isDeleteConfirmVisible"
			:onConfirm="handleConfirmDialogConfirm"
			:onClose="handleConfirmDialogClose"
			primaryActionColor="error"
			><div style="padding-top: 20px">
				{{ $t('text.confirm-deleting-location') }}
			</div></Confirm
		>
	</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Confirm from '@/components/shared/dialogs/confirm/Confirm';
import { mapState } from 'vuex';

export default {
	name: 'LocationsAttrs',
	components: {
		ValidationObserver,
		ValidationProvider,
		Confirm,
	},
	computed: {
		...mapState({
			locations: state => state.locations.items,
		}),
	},
	props: {
		method: {
			type: String,
			required: true,
		},
		location: {
			type: Object,
			required: false,
			default() {
				return {
					active: true,
					name: '',
				};
			},
		},
		onClose: {
			type: Function,
			required: true,
		},
	},
	data() {
		const { location } = this;
		return {
			locationEditable: JSON.parse(JSON.stringify(location)),
			isDeleteConfirmVisible: false,
		};
	},
	methods: {
		handleClose() {
			this.onClose();
		},
		async handleSubmit(evt) {
			if (evt) {
				evt.preventDefault();
			}
			const isValid = await this.$refs.form.validate();
			if (isValid) {
				const { locationEditable, method } = this;
				if (method === 'edit') {
					this.$store
						.dispatch('locations/put', {
							items: [{ ...locationEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				} else if (method === 'add') {
					this.$store
						.dispatch('locations/post', {
							items: [{ ...locationEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				}
			}
		},
		handleConfirmDialogConfirm() {
			const { id } = this.locationEditable;
			this.$store.dispatch('locations/delete', { id }).then(() => {
				this.handleClose();
			});
		},
		handleConfirmDialogClose() {
			this.isDeleteConfirmVisible = false;
		},
		hanleDeleteClick() {
			this.isDeleteConfirmVisible = true;
		},
	},
	watch: {
		location(newVal) {
			this.locationEditable = { ...newVal };
		},
	},
};
</script>
